<template>
    <div class="bg-gray-100 px-4 py-2 text-xl font-medium">
        <slot />
    </div>
</template>
